import React from 'react';
import arrow from 'four-nets/icons/svg/icon_arrow-opposite.svg';

import Select, { Icon, Props as SelectProps } from '../select/select';
import defaultStyles from './ordering-select.scss';

export type Props = Omit<SelectProps, 'styles'>;

class OrderingSelect extends React.PureComponent<Props> {
    render() {
        return <Select style={{ select: defaultStyles.select }} icon={<Icon src={arrow} />} {...this.props} />;
    }
}

export default OrderingSelect;
